<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */

    import { getNavigationFeedbacksStore } from './navigationFeedback.js';
    import FeedbackDialog from './FeedbackDialog.svelte';
    import SecurityMessage from '../plugins/security/Message.svelte';

    /**
     * @typedef {Object} Props
     * @property {string} serviceCallId
     */
    /** @type {Props} */
    let { serviceCallId } = $props();

    // svelte-ignore state_referenced_locally
    const feedbacksStore = getNavigationFeedbacksStore(serviceCallId);
</script>

{#each $feedbacksStore.feedbacksArray as { key, config, onDone } (key)}
    {#if config && (!config.type || config.type !== 'security')}
        <FeedbackDialog {config} {onDone} />
    {:else}
        <SecurityMessage {config} {onDone} />
    {/if}
{/each}
